export const FooterScreen=() => {
    return (
        <>
            <div className="fables-footer-image fables-after-overlay white-color py-4 py-lg-5">
                <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-lg-12">
                            <h2 className="font-20 semi-font fables-second-border-color border-bottom pb-3">Contact us</h2>
                            <div className="my-3">
                                <h4 className="font-16 semi-font mb-3"><span className="fables-iconmap-icon fables-second-text-color pr-2 font-20 mt-1 d-inline-block"></span> Locations</h4>
                                <div className="mt-2 ml-4" style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', color: '#fff' }}>
                                    <div>
                                        <p className="font-14 mb-1" style={{ color: '#fff' }}>700 El Camino Real Suite 120</p>
                                        <p className="font-14 mb-0" style={{ color: '#fff' }}>Menlo Park, CA 94025</p>
                                    </div>
                                    <div>
                                        <p className="font-14 mb-1" style={{ color: '#fff' }}>17595 Harvard Avenue Suite C - 10026</p>
                                        <p className="font-14 mb-0" style={{ color: '#fff' }}>Irvine, CA 92614</p>
                                    </div>
                                </div>
                            </div>
                            <div className="my-3">
                                <h4 className="font-16 semi-font"><span className="fables-iconphone fables-second-text-color pr-2 font-20 mt-1 d-inline-block"></span> Inquire About Partnership </h4>
                                <p className="font-14 fables-fifth-text-color mt-2 ml-4"> <a href="/contact" className="white-color">Contact us</a></p>
                            </div>
                            <div className="my-3">
                                <h4 className="font-16 semi-font"><span className="fables-iconemail fables-second-text-color pr-2 font-20 mt-1 d-inline-block"></span> Email</h4>
                                <p className="font-14 fables-fifth-text-color mt-2 ml-4"><a href="mailto:partnership@kovio.com" className="white-color">partnership@kovio.com</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright fables-main-background-color mt-0 border-0 white-color">
                <p className="mb-0">Copyright © Kovio Inc. All rights reserved.</p>
            </div>
        </>

    )
}